export const GET_ACCOUNTS = 'GET_ACCOUNTS';
export const GET_LOGS = 'GET_LOGS';
export const ADD_ACCOUNTS = 'ADD_ACCOUNTS';
export const DEL_ACCOUNTS = 'DEL_ACCOUNTS';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const DISABLE_ACCOUNTS = 'DISABLE_ACCOUNTS';
export const RESET_ACCOUNTS = 'RESET_ACCOUNTS';
export const ACCOUNT_ERROR = 'ACCOUNT_ERROR';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const CLEAR_SECRETS = 'CLEAR_SECRETS';
export const IN_PROGRESS = 'IN_PROGRESS';
export const SET_STARTTIME = 'SET_STARTTIME';
export const CLEAR_STARTTIME = 'CLEAR_STARTTIME';
export const FILTER_LOGS = 'FILTER_LOGS';
export const CLEAR_LOGFILTER = 'CLEAR_LOGFILTER';
export const FILTER_ACCOUNTS = 'FILTER_ACCOUNTS';
export const CLEAR_ACCOUNTFILTER = 'CLEAR_ACCOUNTFILTER';

